import RestStore from "@shared/svelte/Stores/RestStore";

export default function SalesRepStore({ initial, distributorId }) {
  const store = RestStore(
    initial,
    `api/retailer/distributors/${distributorId}/sales_reps`,
    `sales_rep`,
  );
  return store;
}
